import { Component } from '@angular/core';
import { AuthService } from 'app/services/auth.service';

@Component({
  standalone: false,
  selector: 'app-unauthorized-dialog',
  templateUrl: './unauthorized-dialog.component.html',
  styleUrls: ['./unauthorized-dialog.component.scss']
})
export class UnauthorizedDialogComponent {


  constructor(private authService: AuthService) {}

  logout(){
    this.authService.logout();
  }
}
